<template>
  <div />
</template>

<script>
export default {
    data(){
        return{
             siteID: this.$route.params.siteid,
        }
    },
    mounted(){ 
        localStorage.setItem('referralFlag','1'); 
        setTimeout(()=>{
            this.$router.push('/' + this.siteID + '/home');
        }, 500);
        
    }
}
</script> 